// extracted by mini-css-extract-plugin
export default {"full_page":"base_route_full_page__ezgbZ"};